import { Dispatch, FC, SetStateAction, useCallback } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { IPartialWidgetProps } from '../contactsTableView/models/partialWidgetProps'

import { GpContactsList } from './components/gpContactsList/GpContactsList'
import { IJbpGlobalPartnerPartnersContact } from './components/gpContactsList/models/jbpGlobalPartnerPartnersContact'

interface IGP360ContactsEditorProps extends IPartialWidgetProps {
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
  partnerId: string
  fYear: number
  onSelectProfile: (partner: IJbpGlobalPartnerPartnersContact) => void
}

export const GpContactsListDialog: FC<IGP360ContactsEditorProps> = ({
  showModal,
  setShowModal,
  metrics,
  partnerId,
  flexWidth,
  onSelectProfile,
  fYear,
}) => {
  const handleCloseModal = useCallback(() => {
    setShowModal(false)
  }, [setShowModal])

  return (
    <ModalDialog
      show={showModal}
      content={GpContactsList}
      contentProps={{
        partnerId,
        flexWidth,
        metrics,
        fYear,
        onSelectGpContact: onSelectProfile,
      }}
      onClose={handleCloseModal}
    />
  )
}
